import { HomeOutlined, PhoneOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

export default function TermsOfServicePage() {
  const nav = useNavigate();

  return (
    <div className="flex flex-col bg-[#19181c] text-white px-6 w-full py-16">
      <div className="max-w-4xl mx-auto h-full">
        <div className="mb-12">
          <h1 className="text-5xl font-bold mb-4 text-[#F6B34B]">
            Terms of Service
          </h1>
          <p className="text-white/70 text-sm">Last updated: May 12, 2026</p>
        </div>

        <div className="space-y-10 text-white/90 leading-8">
          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Acceptance of Terms
            </h2>
            <p>
              By accessing or using this application, you agree to comply with
              and be bound by these Terms of Service. Access to the application
              is restricted to authorized users approved by the organization.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Purpose of the Application
            </h2>
            <p>
              This application is a private internal tool designed to assist
              authorized users in creating, scheduling, managing, and publishing
              content to Facebook Pages operated by the organization.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Authorized Use
            </h2>

            <p className="mb-4">
              Users agree to use the application only for legitimate
              organizational purposes and in accordance with all applicable
              laws, platform rules, and company policies.
            </p>

            <ul className="list-disc pl-6 space-y-2 text-white/80">
              <li>
                Users must maintain the confidentiality of login credentials
              </li>
              <li>Unauthorized access attempts are strictly prohibited</li>
              <li>
                Users may not use the application to publish unlawful,
                misleading, abusive, or infringing content
              </li>
              <li>
                Users are responsible for the accuracy and legality of submitted
                content
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Facebook Platform Compliance
            </h2>
            <p>
              Use of this application is also subject to applicable Facebook
              platform terms, policies, developer requirements, and community
              standards. Users are responsible for ensuring their use complies
              with Facebook requirements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Account Access and Security
            </h2>
            <p>
              Users are responsible for maintaining the security of their
              Facebook accounts and any credentials used to access the
              application. The organization reserves the right to revoke access
              at any time for operational, security, or policy reasons.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Cookies and Analytics
            </h2>

            <p>
              This application may use cookies and similar technologies to
              support authentication, maintain user sessions, improve
              functionality, and analyze application performance and usage
              patterns.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Google Analytics
            </h2>

            <p>
              We may use Google Analytics and related analytics services to
              better understand how users interact with the application. These
              services may collect information such as pages visited, session
              duration, browser type, device information, and general geographic
              region.
            </p>

            <p className="mt-4">
              Analytics data is used solely to improve application performance,
              reliability, usability, and operational decision-making.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Types of Cookies We Use
            </h2>

            <ul className="list-disc pl-6 space-y-2 text-white/80">
              <li>
                Essential cookies required for authentication and secure
                application functionality
              </li>

              <li>
                Session cookies used to maintain active login sessions and
                preferences
              </li>

              <li>
                Analytics cookies used to measure usage patterns and application
                performance
              </li>

              <li>
                Security-related cookies used to help detect unauthorized access
                or abuse
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Managing Cookies
            </h2>

            <p>
              Most web browsers allow users to control or disable cookies
              through browser settings. Disabling certain cookies may affect the
              functionality, authentication, or performance of the application.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Intellectual Property
            </h2>
            <p>
              All software, branding, workflows, and related materials
              associated with this application remain the property of the
              organization unless otherwise stated. Users may not reproduce,
              distribute, reverse engineer, or commercially exploit the
              application without authorization.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Service Availability
            </h2>
            <p>
              The application is provided on an “as available” basis. The
              organization does not guarantee uninterrupted operation,
              availability, or compatibility with third-party services including
              Facebook APIs and infrastructure.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Limitation of Liability
            </h2>
            <p>
              To the maximum extent permitted by law, the organization shall not
              be liable for any indirect, incidental, consequential, or business
              interruption damages arising from the use of this application,
              including issues resulting from third-party platform outages,
              account restrictions, or publishing failures.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Termination
            </h2>
            <p>
              Access to the application may be suspended or terminated at any
              time without notice where necessary to maintain security,
              operational integrity, legal compliance, or organizational policy
              enforcement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Changes to These Terms
            </h2>
            <p>
              These Terms of Service may be updated periodically to reflect
              changes in operational practices, platform requirements, or legal
              obligations. Continued use of the application constitutes
              acceptance of any updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3 text-[#F6B34B]">
              Contact
            </h2>

            <p>
              For questions regarding these Terms of Service or the operation of
              this application, please contact your organization administrator.
            </p>

            <div className="flex justify-end gap-4 mt-6">
              <Button
                type="primary"
                size="large"
                onClick={() => nav("/contact")}
                className="text-white hover:bg-[#F6B34B]/90 transition-colors"
              >
                <PhoneOutlined style={{ marginRight: "0.5rem" }} />
                CONTACT US
              </Button>

              <Button type="default" size="large" onClick={() => nav("/")}>
                <HomeOutlined style={{ marginRight: "0.5rem" }} />
                HOME
              </Button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
